<template>
  <footer class="text-muted py-3 text-center">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="logo mb-1">
            <img
              src="../assets/logo.png"
              alt="Landbobank Team Challenge"
              height="40"
            />
          </div>
          <small>
            Landbobank Team Challenge {{this.$root.datetime.year}}
          </small>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "FOOTER"
};
</script>
